import preLockedMap from "./preLockedMap.component";

const preLockedMapModule = angular
  .module("app.components.preLockedMap", [])
  .component("preLockedMap", preLockedMap);

export default preLockedMapModule;



// WEBPACK FOOTER //
// ./src/components/preLockedMap/preLockedMap.module.js